import { useEffect, useState } from "react";
import { Download, ArrowUpRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SECTION_LINKS = [
  { href: "#about", testid: "nav-about", label: "About" },
  { href: "#career", testid: "nav-career", label: "Career" },
  { href: "#campaigns", testid: "nav-campaigns", label: "Campaigns" },
  { href: "#clients", testid: "nav-clients", label: "Clients" },
  { href: "#next", testid: "nav-next", label: "What's Next" },
];

const NavLinks = () => (
  <div className="hidden lg:flex items-center gap-7 text-[11px] tracking-[0.18em] uppercase font-medium">
    {SECTION_LINKS.map((l) => (
      <a
        key={l.href}
        href={l.href}
        data-testid={l.testid}
        className="hover:opacity-60 transition-opacity"
      >
        {l.label}
      </a>
    ))}
  </div>
);

const NavActions = () => {
  const downloadHref = `${BACKEND_URL}/api/resume/download`;
  return (
    <div className="flex items-center gap-3">
      <a
        href="mailto:kankariayash97@gmail.com"
        data-testid="nav-contact"
        className="hidden md:inline-flex items-center gap-1 text-[11px] tracking-[0.18em] uppercase font-medium hover:opacity-60 transition-opacity"
      >
        Contact <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.5} />
      </a>
      <a
        href={downloadHref}
        data-testid="download-resume-btn"
        className="group inline-flex items-center gap-2 bg-[var(--ink)] text-[var(--paper)] px-4 md:px-5 py-2.5 text-[10.5px] md:text-[11px] tracking-[0.2em] uppercase font-medium hover:bg-[var(--paper)] hover:text-[var(--ink)] border border-[var(--ink)] transition-colors"
      >
        <Download className="w-3.5 h-3.5" strokeWidth={1.75} />
        Resume PDF
      </a>
    </div>
  );
};

const NavLogo = () => (
  <a
    href="#top"
    data-testid="nav-logo"
    className="text-[11px] md:text-xs font-bold tracking-[0.22em] uppercase"
  >
    YK <span className="text-[var(--accent)]">·</span>{" "}
    <span className="hidden sm:inline opacity-60">Kankaria</span>
  </a>
);

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 16);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      data-no-print="true"
      data-testid="primary-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-[var(--paper)]/85 backdrop-blur-md border-b hairline"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 flex items-center justify-between h-14 md:h-16">
        <NavLogo />
        <NavLinks />
        <NavActions />
      </div>
    </nav>
  );
};
